import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationSignaturePluginService } from './signature.service';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ModalComponent } from '../../../modal/modal.component';
import { LoadSpinnerService } from '../../../shared/services';
import * as _ from 'lodash';
import { InstallationSignatureMenuComponent } from '../../../menus';
import { ContactsModalComponent } from '../../../shared/components';

@Component({
    selector: 'installation-signature-edit',
    templateUrl: './signature-edit.component.html',
    standalone: false
})
export class InstallationSignatureEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  types: any[];
  currentItem: any;

  @ViewChild('typesModal', { static: true }) typesModal: ModalComponent;
  @ViewChild('signatureDeleteConfirm', { static: true }) signatureDelete: ConfirmComponent;
  @ViewChild('importCustomersModal') importCustomersModal: ModalComponent;

  public menuComponent = InstallationSignatureMenuComponent;
  private signatureToRemove: number;
  private sub = new Subscription();
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationSignaturePluginService,
    private fb: UntypedFormBuilder,
    protected loader: LoadSpinnerService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['signatures'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateSignature(this.inspectionId, this.pointId, this.pluginId, model.signatures)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public onClose(e: any) {
    this.currentItem.controls['type'].markAsTouched();
  }

  public selectTypeMenu(item: any) {
    const selectedIndex = this.currentItem.controls['type'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['type'].setValue(selectedIndex);
  }

  public openTypeSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.typesModal, this.types, selectedIndex ?? -1);
    this.currentItem = this.formData.controls[i];
  }

  public add(el?: any) {
    this.formData.push(this.initSignature(el));
  }

  public openSignatureDeleteConfirm(i: number) {
    this.signatureDelete.open();
    this.signatureToRemove = i;
  }

  public remove(e: any) {
    this.formData.removeAt(this.signatureToRemove);
  }

  importBobstContacts() {
    this.loader.showSpinner();
    this.pluginService.getBobstContacts(this.inspectionId).subscribe((contacts) => {
      setTimeout(() => {
        this.loader.hideSpinner();
        contacts.forEach((c) => this.add(c));
      }, 100);
    });
  }

  importCustomerContacts() {
    this.loader.showSpinner();
    this.pluginService.getCustomerContacts(this.inspectionId).subscribe((contacts) => {
      setTimeout(() => {
        this.loader.hideSpinner();
        contacts.forEach((c) => this.add(c));
      }, 100);
    });
  }

  saveSignature(data: string, i: number) {
    const formGroup: any = this.formData.controls[i];
    formGroup.controls['signatureImage'].setValue(data);
  }

  selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      case 20:
        this.openImportBobstContactsModal();
        break;
      case 30:
        this.openImportCustomerContactsModal();
        break;
      default:
    }
  }

  openImportBobstContactsModal() {
    this.loader.showSpinner();
    this.pluginService.getBobstContacts(this.inspectionId).subscribe((contacts) => {
      this.loader.hideSpinner();
      this.importCustomersModal.modalFooter = false;
      this.importCustomersModal.modalHeader = false;
      this.importCustomersModal.modalMessage = false;
      this.importCustomersModal.open(ContactsModalComponent, _.cloneDeep(contacts));
    });
  }

  openImportCustomerContactsModal() {
    this.loader.showSpinner();
    this.pluginService.getCustomerContacts(this.inspectionId).subscribe((contacts) => {
      this.loader.hideSpinner();
      this.importCustomersModal.modalFooter = false;
      this.importCustomersModal.modalHeader = false;
      this.importCustomersModal.modalMessage = false;
      this.importCustomersModal.open(ContactsModalComponent, _.cloneDeep(contacts));
    });
  }

  addImports(data: any = null) {
    if (Array.isArray(data)) {
      _.forEach(data, (el) => this.add(el));
    } else if (data) {
      this.add(data);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.types = this.pluginService.getSignatureTypes();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      signatures: this.fb.array([])
    });

    _.forEach(this.plugin.config.Signatures, (el) => {
      this.formData.push(this.initSignature(el));
    });
  }

  private initSignature(el?: any) {
    return this.fb.group({
      type: new UntypedFormControl(el?.Type ?? -1),
      firstName: new UntypedFormControl(el?.FirstName ?? ''),
      lastName: new UntypedFormControl(el?.LastName ?? ''),
      jobFunction: new UntypedFormControl(el?.JobFunction ?? ''),
      place: new UntypedFormControl(el?.Place ?? ''),
      dateValue: new UntypedFormControl(el?.DateValue ?? ''),
      signatureImage: new UntypedFormControl(el?.SignatureImage ?? '')
    });
  }
}
